import { alpha } from "@mui/material/styles";

import { TINT } from "./tint";

// ----------------------------------------------------------------------

// SETUP COLORS
const GREY = {
  0: "#FFFFFF",
  100: "#F9FAFB",
  200: "#F4F6F8",
  300: "#DFE3E8",
  400: "#C4CDD5",
  500: "#919EAB",
  600: "#637381",
  700: "#454F5B",
  800: "#212B36",
  900: "#161C24",
};

// The shades of a tone, by contrast against white (palette.test.js checks them):
//   lighter – a pale shade, rarely used
//   light   – the vivid shade that tints are made of (theme/tint.js) and outlined Alerts framed in
//   main    – text, icons and buttons: at least 4.5:1, also for white text on it
//   dark    – hover and emphasised text, about 7:1
//   darker  – text on a tint, about 10:1
const PRIMARY = {
  lighter: "#eab260",
  light: "#D08000", // the orange of the logo
  main: "#9A6311",
  dark: "#794E0D",
  darker: "#58380A",
  contrastText: "#fff",
};

const SECONDARY = {
  lighter: "#bababa",
  light: "#A0A0A0",
  main: "#6F6F6F",
  dark: "#575757",
  darker: "#3E3E3E",
  contrastText: "#fff",
};

const INFO = {
  lighter: "#fcc06c",
  light: "#F2730A",
  main: "#B35407",
  dark: "#8C4206",
  darker: "#663004",
  contrastText: "#fff",
};

const SUCCESS = {
  lighter: "#E9FCD4",
  light: "#2DAE24",
  main: "#21801A",
  dark: "#1A6415",
  darker: "#13490F",
  contrastText: "#fff",
};

const WARNING = {
  lighter: "#FFF7CD",
  light: "#F2B200",
  main: "#8F6900",
  dark: "#705200",
  darker: "#513B00",
  contrastText: "#fff",
};

const ERROR = {
  lighter: "#FFE7D9",
  light: "#E26B69",
  main: "#D42B28",
  dark: "#A72220",
  darker: "#7A1917",
  contrastText: "#fff",
};

const palette = {
  common: { black: "#000", white: "#fff" },
  primary: PRIMARY,
  secondary: SECONDARY,
  info: INFO,
  success: SUCCESS,
  warning: WARNING,
  error: ERROR,
  grey: GREY,
  divider: alpha(GREY[500], 0.36),
  text: {
    primary: GREY[800],
    secondary: GREY[600],
    disabled: GREY[500],
  },
  background: {
    paper: "#fff",
    default: GREY[100],
    neutral: GREY[200],
  },
  action: {
    active: GREY[600],
    hover: alpha(GREY[500], TINT.hover),
    selected: alpha(GREY[500], TINT.selected),
    disabled: alpha(GREY[500], 0.8),
    disabledBackground: alpha(GREY[500], 0.24),
    focus: alpha(GREY[500], 0.24),
    hoverOpacity: TINT.hover,
    selectedOpacity: TINT.selected,
    disabledOpacity: 0.48,
  },
};

export default palette;
